import { AppEffects } from './app.effect';
import { ContentEffects } from './content.effect';
import { MyAccountEffects } from './my-account.effect';
import { AnalyticsEffects } from './analytics.effect';
import { UserManagementEffects } from './user-management.effect';
import { Type } from '@angular/core';
import { FunctionalEffect } from '@ngrx/effects';

export const effects: Array<Type<unknown> | Record<string, FunctionalEffect>> = [
    AppEffects,
    MyAccountEffects,
    ContentEffects,
    AnalyticsEffects,
    UserManagementEffects
];
